import get from 'lodash.get';

const getTemplateBuildSlug = (rootState) => get(rootState, 'sites.templateBuildSlug', null);

export default getTemplateBuildSlug;
